<template>
  <div class='t_content_view'>
    <!-- 标题 -->
    <div class="t_title_box_f">
      <div class="t_blue_line"></div>
      <div>发送内容</div>
    </div>
    <div class="t_con_box_f">
      <div class="t_con_title_f">任务名称：</div>
      <div class="t_speak_box">
        <el-input v-model="sendtitle"     clearable />
      </div>
    </div>
    
    <div class="t_con_box_f">
      
      <div class="t_con_title_f">朋友圈文案：</div>
      <div style="position:relative" >
        <div class="t_speak_box">
          <el-input v-model="emojisOutput" class="t_speak_input"  rows="10" type="textarea"  clearable />
          <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
        </div>
        
        <Picker style="position: absolute;top: 0;left: 500px;" v-if='isshowemoji' :data="emojiIndex" set="twitter" @select="selectEmoji" />
      </div>
    </div>
    <div class="t_con_box_f">
      <div class="t_con_title_f">朋友圈内容：</div>
      <div >
        <div>
          <el-checkbox @change="checked=>choosetype(checked,1)" v-model="text_type" label="纯文本" size="large" />
          <el-checkbox @change="checked=>choosetype(checked,2)" v-model="img_type" label="图片" size="large" />
          <el-checkbox @change="checked=>choosetype(checked,3)" v-model="video_type" label="视频" size="large" />
          <el-checkbox @change="checked=>choosetype(checked,4)" v-model="web_type" label="网页" size="large" />
        </div>
        <!-- 图片 -->
        <div v-if="img_type" class="t_up_img_box" style="width: 600px;margin-top: 30px;">
          <el-upload
            v-model:file-list="fileList_img.data"
            :limit="9"
            :data="upData"
            :action=upload_img
            list-type="picture-card"
            accept="image/jpg,image/png,image/jpeg" 
            :on-success="successimg"
            :before-upload="beforeImageUpload"
            :on-preview="handlePreview"
            :headers="headers"
          >
            <!-- <el-button >选择图片</el-button>
            <el-button link type='primary'>从素材库选择</el-button> -->
            <el-icon><Plus /></el-icon>
            <template #tip>
              <div class="el-upload__tip">
                <div>1.图片大小不能超过10MB，支持JPG、PNG格式，最多9张</div>
                <div>2.普通图片：不超过1440x1080，长图片：长边建议不超过1080px。</div>
              </div>
            </template>
            <!-- <template #file="{ file }">
              <div>
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              </div>
            </template> -->
          </el-upload>
        </div>
        <el-dialog v-model="dialogVisible">
          <img style="width: 100%;" :src="dialogImageUrl" />
        </el-dialog>
        <!-- 视频 -->
        <div v-if="video_type" class="t_up_video_box" style="width: 600px;margin-top: 30px;">
          <el-upload
            v-model:file-list="fileList_video.data"
            :limit="1"
            :data="upData"
            :action=upload_video
            accept="video/mp4" 
            :on-success="successvideo"
            :before-upload="beforeVideoUpload"
            :headers="headers"
          >
            <el-button >选择视频</el-button>
            <template #tip>
              <div class="el-upload__tip">
                <div>视频不超过10MB，支持MP4格式，朋友圈类型视频时长不超过30秒</div>
              </div>
            </template>
          </el-upload>
        </div>
        <!-- 网站 -->
        <div v-if="web_type" class="t_up_img_box" style="width: 600px;margin-top: 30px;">
          <div class="t_web_title">网站标题:</div>
          <el-input style="width: 460px;" placeholder="请输入标题" v-model="webtitle"  clearable />
          <div class="t_web_title" style="margin-top:20px">网站地址:</div>
          <el-input style="width: 460px;" placeholder="请输入网址" v-model.trim="weblink"  clearable />
          <div class="t_web_title" style="margin-top:20px">缩略图:</div>
          <el-upload
            v-model:file-list="fileList_webimg.data"
            :limit="1"
            :data="upData"
            :action=upload_webimg
            list-type="picture"
            accept="image/jpg,image/png,image/jpeg" 
            :on-success="successwebimg"
            :before-upload="beforeWebUpload"
            :headers="headers"  
          >
            <el-button >选择图片</el-button>
            <template #tip>
              <div class="el-upload__tip">
                <div>1.图片大小不能超过10MB，支持JPG、PNG格式，最多9张</div>
                <div>2.普通图片：不超过1440x1080，长图片：长边建议不超过1080px。</div>
              </div>
            </template>
          </el-upload>
        </div>
      </div>
    </div>
    <!-- line -->
    <div class="t_line"></div>
    <!-- 标题 -->
    <div class="t_title_box_f">
      <div class="t_blue_line"></div>
      <div>发送设置</div>
    </div>
    <div class="t_con_box_f">
      <div class="t_con_title_f">选择发表成员：</div>
      <div>
        <!-- <el-select  multiple v-model="userIds.data" placeholder="请选择成员">
            <el-option style="height: auto;line-height: normal;padding:8px 32px 8px 20px" v-for="(item,index) in allpeolist.data" 
            :key="index"
             :value="item.id" :label="item.name" >
            </el-option>
        </el-select> -->
        <el-cascader
            v-model="selectedPath.data"
            :options="allcomppeolist.data"
            :props="{ expandTrigger: 'hover',multiple: true }"
            placeholder="请选择成员"
            clearable
            @change="handleChange"
            />
      </div>
    </div>
    <!-- <div class="t_con_box_f">
      <div class="t_con_title_f">选择客户：</div>
      <div>
        <div>
          <el-checkbox @change="allkhchange" v-model="allkh" label="全部客户" size="large" />
          <el-checkbox @change="choosekhchange" v-model="choosekh" label="按条件筛选" size="large" />
        </div>
        
        <div v-if="sxmodel&&isshowtips" class="t_sxtips">
          任务执行时，将过滤带有排除标签的客户，条件越多筛选客户时间越长
          <Close @click="closetips" style="width: 13px;cursor:pointer" />
        </div>
        <div v-if="sxmodel" class="t_sxbox" >
          <div class="t_sxtitle">指定条件的客户</div>
          
          <chooseTag :choosedtag="choosedtag" :bqData="bqData" @changechoosedtag="changechoosedtag"
                 @changebqData = 'changebqData'
                 />
        </div>
      </div>
    </div> -->
    <div class="t_con_box_f">
      <div class="t_con_title_f">发送时间：</div>
      <div>
        <div>
          <el-checkbox @change="nowsendchange" v-model="nowsend" label="立即发送" size="large" />
        </div>
        <div>
          <el-checkbox @change="timesendchange" 
          style="margin-right: 20px;" v-model="timesend" label="定时发送" size="large" />
          <el-date-picker
            class="t_choosetime"
            v-model="sendtime"
            value-format="YYYY-MM-DD HH:mm:ss"
            type="datetime"
            placeholder="请选择时间"
          />
        </div>
      </div>
    </div>
    <div class="t_con_box_f">
      <el-button  color="#4F46E5" @click="sendfriend" style="margin-left:150px" type="primary">发送</el-button>
    </div>
  </div>
   <!-- 选择标签 -->
   <!-- <el-dialog v-model="isqdtag" title="选择渠道标签" width="500px" >
        <div class="t_tagchoose_box" v-for="(item,index) in bqData.data" :key="index">
            <div>{{item.title}}</div>
            <div>
                <el-check-tag v-for="(item2,index2) in item.tagList" :key="index2" 
                class="t_all_tag"
                :checked="item2.checked" @change="onChange(index,index2)">{{item2.title}}</el-check-tag>
            </div>
        </div>
        <div class="t_cz_box">
            <el-button color="#4F46E5" @click="choosesub" type="primary">确定</el-button>
        </div>
    </el-dialog> -->
</template>

<script setup>
// Import data/twitter.json to reduce size, all.json contains data for
// all emoji sets.
import data from "emoji-mart-vue-fast/data/all.json";
// Import default CSS
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";


import { Delete, Edit, Search, Share, Upload, Plus, Close ,ZoomIn} from '@element-plus/icons-vue'
import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox,UploadProps, UploadUserFile } from 'element-plus'
import { bqlist,addfriend,getcircle,newsendfriend,newgetpeo,newsendfrienddetail,newgetcomppeo,newsendfriendv2,newgethmcreatev2} from '@/assets/js/common.js'
import chooseTag from '../components/chooseTag.vue';
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()

//动态获取接口地址
const _url2 = inject('_url2')
const _urlfile = '/api/upload/file'
const _urlnew = inject('_urlnew')

const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}

onMounted(() => {
    //获取所有成员下拉
    getallpeolist()
    //获取标签列表
    // getbqlist()
    //获取主体+成员
    getcomppeolist()

    //回显朋友圈内容
    if(route.query.id){
      newsendfrienddetail({id:route.query.id}).then((response)=>{
        console.log('回显')
        console.log(response.data.data)
        emojisOutput.value = response.data.data.content
        if(response.data.data.type==1){
          text_type.value = true
          img_type.value = false
          video_type.value = false
          web_type.value = false
        }
        if(response.data.data.type==2){
          text_type.value = false
          img_type.value = true
          video_type.value = false
          web_type.value = false
          if(response.data.data.images){
            for(var x = 0;x<response.data.data.images.length;x++){
              fileList_img.data.push({
                response:{
                  data:{
                    url:response.data.data.images[x].url,
                    media_id:response.data.data.images[x].media_id
                  }
                },
                url:response.data.data.images[x].url
              })
            }
          }
        }
        if(response.data.data.type==4){
          text_type.value = false
          img_type.value = false
          video_type.value = true
          web_type.value = false
          if(response.data.data.video){

            fileList_video.data.push({
                response:{
                  data:{
                    url:response.data.data.video.url,
                    media_id:response.data.data.video.media_id
                  }
                },
                url:response.data.data.video.url,
              
              })


            // for(var x = 0;x<response.data.data.video.length;x++){
            //   fileList_video.data.push({
            //     response:{
            //       data:{
            //         url:response.data.data.video[x].url,
            //         media_id:response.data.data.video[x].media_id
            //       }
            //     },
            //     url:response.data.data.video[x].url,
            //     // name:response.data.data.video[x].media_id.split('/')[5]
            //   })
            // }
          }
        }
        if(response.data.data.type==3){
          text_type.value = false
          img_type.value = false
          video_type.value = false
          web_type.value = true

          webtitle.value = response.data.data.share_title
          weblink.value = response.data.data.share_url
          if(response.data.data.share_image){

            fileList_webimg.data.push({
                response:{
                  data:{
                    url:response.data.data.share_image.url,
                    media_id:response.data.data.share_image.media_id
                  }
                },
                url:response.data.data.share_image.url
              })
            
            // for(var x = 0;x<response.data.data.share_image.length;x++){
             
            //   fileList_webimg.data.push({
            //     response:{
            //       data:{
            //         url:response.data.data.share_image[x].url,
            //         media_id:response.data.data.share_image[x].media_id
            //       }
            //     },
            //     url:response.data.data.share_image[x].url
            //   })
            // }
          }
        }
        // if(response.data.data.sendTime){
        //   sendtime.value = response.data.data.sendTime
        //   nowsend.value = false
        //   timesend.value = true
        // }
        
        var senderarr = []
        for(var x = 0;x<response.data.data.sender.length;x++){
          senderarr.push(response.data.data.sender[x]*1)
        }
        userIds.data = senderarr

        //将一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]转为二维数组[[1,2],[3,4]]格式
        selectedPath.data = []
        selectedPath.data = response.data.data.corp_members?.map(item => [item.corp_id, item.id]) || []
        console.log('selectedPath.data')
        console.log(response.data.data.corp_members)
        console.log(selectedPath.data)


      })
    }
})


const emojiIndex = new EmojiIndex(data)
//输入框内容
const emojisOutput = ref('')
const selectEmoji = (emoji)=> {
  emojisOutput.value = emojisOutput.value + emoji.native;
}
//是否显示emoji选择框
const isshowemoji = ref(false)
//打开emoji选择框
const showemoji = ()=>{
  isshowemoji.value=!isshowemoji.value
}

//朋友圈内容选择
const text_type = ref(true)
const img_type = ref(false)
const video_type = ref(false)
const web_type = ref(false)
//选择种类
const choosetype = (value,type)=>{
  console.log(value,type)
  if(value){
    fileList_img.data=[]
    fileList_video.data=[]
    fileList_webimg.data=[]
    if(value&&type==1){
      text_type.value=true
      img_type.value=false
      video_type.value=false
      web_type.value=false
    }else if(value&&type==2){
      text_type.value=false
      img_type.value=true
      video_type.value=false
      web_type.value=false
    }else if(value&&type==3){
      text_type.value=false
      img_type.value=false
      video_type.value=true
      web_type.value=false
    }else if(value&&type==4){
      text_type.value=false
      img_type.value=false
      video_type.value=false
      web_type.value=true
    }
  }else{
    if(type==1){
      text_type.value=true
    }else if(type==2){
      img_type.value=true
    }else if(type==3){
      video_type.value=true
    }else if(type==4){
      web_type.value=true
    }
  }
  
}


const upData=reactive(
  {  file_type: '' }
)  // 上传文件data

//上传图片地址http://91fen.vip:15086/fileUpload
const upload_img = _urlfile
// const headers = reactive({
//   'token': $cookies.get("fanstoken")
// })
//上传图片列表
const fileList_img = reactive({
  data:[]
})
const beforeImageUpload = (file)=> {
  
  // upData.file = file
  upData.file_type = 'image'
  
}
//上传图片成功
const successimg = (val)=>{
  //上传失败
  if(val.code==500){
    ElMessage.error('图片质量不超过10MB，图片尺寸不超过1440 x 1080')
    fileList_img.data.pop()
  }
  console.log(val)
  console.log(fileList_img.data)
}
const dialogVisible = ref(false)
const dialogImageUrl = ref('')
//查看大图
const handlePreview = (file)=>{
  console.log('查看大图')
  console.log(file)
  dialogVisible.value = true
  dialogImageUrl.value = file.url
}





//上传视频地址
const upload_video = _urlfile
//上传文件列表
const fileList_video = reactive({
  data:[]
})
const beforeVideoUpload = (file)=> {
  
  // upData.file = file
  upData.file_type = 'video'
  
}
//上传视频成功
const successvideo = (val)=>{
  
  //上传失败
  if(val.code==500){
    ElMessage.error('视频不超过10MB，朋友圈类型视频时长不超过30秒')
    fileList_video.data.pop()
  }
  console.log(val)
  console.log(fileList_video.data)
}



//网站标题
const webtitle = ref('')
//网站地址
const weblink = ref('')
//上传网站缩略图片地址
const upload_webimg =  _urlfile
//上传网站缩略图片列表
const fileList_webimg = reactive({
  data:[]
})
const beforeWebUpload = (file)=> {
  
  // upData.file = file
  upData.file_type = 'image'
  
}
//上传网站缩略图片成功
const successwebimg = (val)=>{
  //上传失败
  if(val.code==500){
    ElMessage.error('图片质量不超过10MB，图片尺寸不超过1440 x 1080')
    fileList_webimg.data.pop()
  }
  console.log(val)
  console.log(fileList_webimg.data)
}


//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
  newgetpeo().then((response)=>{
        if (response.data.msg.code == 0) {
             console.log('成员==')
             console.log(response.data)
            allpeolist.data = response.data.data
        }
    })
}
//选择成员
const userIds = reactive({
  data:[]
})

//选择客户
//是否展示筛选模块
const sxmodel = ref(false)
//全部客户
const allkh = ref(true)
//全部客户状态改变
const allkhchange = (val)=>{
  if(val){
    choosekh.value = false
    sxmodel.value = false
  }else{
    allkh.value = true
  }
}

//按条件筛选
const choosekh = ref(false)
//按条件筛选送状态改变
const choosekhchange = (val)=>{
  if(val){
    allkh.value = false
    sxmodel.value = true
  }else{
    choosekh.value = true
  }
}

//关闭tips
const isshowtips = ref(true)
const closetips = ()=>{
  isshowtips.value = false
}



//////////////////////////////////

//选择标签组件需要的数据

//选中的标签数组
// const choosedtag = reactive({
//     data:[]
// })
//监听子组件传来的数据
// const changechoosedtag = (e)=>{
//     choosedtag.data = e
// }
// 全部标签
// const bqData = reactive({
//     data:[]
// })
//监听子组件传来的数据
// const changebqData = (e)=>{
//     bqData.data = e
// }
//获取标签列表
// const getbqlist = ()=>{
//     bqlist(_url2).then((response)=>{
//         // console.log(response)
//         if (response.data.msg.code == 0) {
//             bqData.data = response.data.data
//             //添加是否选中状态
//             for(var i=0;i<bqData.data.length;i++){
//                 for(var x=0;x<bqData.data[i].tagList.length;x++){
//                     bqData.data[i].tagList[x].checked=false
//                 }
//             }
//         }
//     })
// }
////////////////////////////////

//选择渠道标签弹窗
// const isqdtag = ref(false)
// const choosetag = ()=>{
//     isqdtag.value=true
// }
// //选中的标签数组
// const choosedtag = reactive({
//     data:[]
// })
// //删除选中标签
// const handleClose = (item,index)=>{
//     console.log(item)
//     choosedtag.data.splice(index, 1)
//     //将选中状态修改为未选中状态
//     for(var i=0;i<bqData.data.length;i++){
//         //找到父级
//         if(bqData.data[i].id==item.groupId){
//             for(var x=0;x<bqData.data[i].tagList.length;x++){
//                 //找到子集
//                 if(bqData.data[i].tagList[x].id==item.id){
//                     //改为未选中
//                     bqData.data[i].tagList[x].checked=false
//                 }
//             }
//         }
        
//     }
// }
// // 全部标签
// const bqData = reactive({
//     data:[]
// })
// //获取标签列表
// const getbqlist = ()=>{
//     bqlist(_url2).then((response)=>{
//         // console.log(response)
//         if (response.data.msg.code == 0) {
//             bqData.data = response.data.data
//             //添加是否选中状态
//             for(var i=0;i<bqData.data.length;i++){
//                 for(var x=0;x<bqData.data[i].tagList.length;x++){
//                     bqData.data[i].tagList[x].checked=false
//                 }
//             }
//         }
//     })
// }
// //切换标签选中事件
// const onChange = (i1,i2)=>{
//     bqData.data[i1].tagList[i2].checked=!bqData.data[i1].tagList[i2].checked
// }
// //确定选择
// const choosesub = ()=>{
//     isqdtag.value=false
//     choosedtag.data=[]
//     for(var i=0;i<bqData.data.length;i++){
//         for(var x=0;x<bqData.data[i].tagList.length;x++){
//             if(bqData.data[i].tagList[x].checked){
//                 choosedtag.data.push(bqData.data[i].tagList[x])
//             }
//         }
//     }
//     console.log(choosedtag.data)
// }





//是否展示客户数量
// const showkhcount = ref(false)
// //计算满足条件的客户数量
// const jskhcount = ()=>{
//   showkhcount.value = true
// }


//发送时间
//立即发送
const nowsend = ref(true)
//立即发送状态改变
const nowsendchange = (val)=>{
  if(val){
    timesend.value = false
    sendtime.value = ''
  }else{
    nowsend.value = true
  }
}
//定时发送
const timesend = ref(false)
//定时发送状态改变
const timesendchange = (val)=>{
  if(val){
    nowsend.value = false
  }else{
    timesend.value = true
  }
}
//发送时间
const sendtime = ref('')

//任务名称
const sendtitle = ref('')

//发送
const sendfriend = ()=>{

  var imagesarr = []
  var videoarr = {}
  var shareimagearr = {}
  //判断发送类型
  if(text_type.value){
    var msgtype = 1
    // var attachments = []
  }else if(img_type.value){
    var msgtype = 2
    
    for(var x = 0;x<fileList_img.data.length;x++){
      imagesarr.push({"media_id":fileList_img.data[x].response.data.media_id,"url":fileList_img.data[x].response.data.url })
    }
  }else if(video_type.value){
    var msgtype = 4
    
    for(var x = 0;x<fileList_video.data.length;x++){
      // videoarr.push({"media_id":fileList_video.data[x].response.data.media_id,"url":fileList_video.data[x].response.data.url })

      videoarr.media_id = fileList_video.data[x].response.data.media_id
      videoarr.url = fileList_video.data[x].response.data.url
    }
  }else if(web_type.value){
    var msgtype = 3
    
    for(var x = 0;x<fileList_webimg.data.length;x++){
      // shareimagearr.push({"media_id":fileList_webimg.data[x].response.data.media_id,"url":fileList_webimg.data[x].response.data.url })

      shareimagearr.media_id = fileList_webimg.data[x].response.data.media_id
      shareimagearr.url = fileList_webimg.data[x].response.data.url

    }
  }

  //发送时间
   if(nowsend.value){
     var sendTime = getNowDate()
   }else{
    
     if(sendtime.value){
       var sendTime = sendtime.value
     }else{
          ElMessage.error('请选择发送时间')
          return
     }
   }

  //判断是否选择了发送成员
  if(selectedPath.data.length==0){
    ElMessage.error('请选择发送成员')
    return
  }

  //发送人及发送标签
  // if(allkh.value){
  //   //全部人
  //   var visibleRange = {
  //     "sender_list":{
  //       "user_list":userIds.data
  //     }
  //   }
  // }else{
  //   var tag_list = []
  //   for(var x=0;x<choosedtag.data.length;x++){
  //     tag_list.push(choosedtag.data[x].tagId)
  //   }
  //   var visibleRange = {
  //     "sender_list":{
  //       "user_list":userIds.data
  //     },
  //     "external_contact_list":{
  //       "tag_list":tag_list
  //     }
  //   }
  // }
  
  //判断是否填写任务名称
  if(sendtitle.value==''){
    ElMessage.error('请填写任务名称')
    return
  }

  var corp_members = []
  //讲二维数组[[1,2],[3,4]]转为一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]格式
    corp_members = selectedPath.data.map(item => ({
        corp_id: item[0],
        id: item[1]
    }))

  var obj={
    title:sendtitle.value,
    content:emojisOutput.value,
    type:msgtype,
    images:imagesarr,
    share_image:shareimagearr,
    video:videoarr,
    share_title:webtitle.value,
    share_url:weblink.value,
    // attachments:attachments,
     publish_time:sendTime,
    sender:userIds.data,
    corp_members:corp_members
  }
  console.log(obj)

  

  ElMessageBox.confirm(
    '是否确认发送',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      newsendfriendv2(obj).then((response)=>{
        console.log(response)
        if(response.data.msg.code==0){
          ElMessage({
            message: '推送成功',
            type: 'success',
          })
          // location.reload();
          router.push({path: '/navxxcd/circlelist'})
        }
      
      })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })

  
}

//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})
//获取主体+成员下拉
const getcomppeolist = ()=>{
    newgetcomppeo().then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data.map(corp => {
                const hasDevices = corp.device && corp.device.length > 0;
                return {
                value: corp.corp_id,
                label: corp.corp_name,
                // 无设备时禁用该项并清空 children
                disabled: !hasDevices,
                children: hasDevices
                    ? corp.device.map(device => ({
                        value: device.id,
                        label: device.name,
                        // 可添加其他自定义属性，如在线状态图标等
                        // 此处保留原始设备对象以便扩展
                        rawDevice: device
                    }))
                    : []
                };
            });
           console.log('主体+成员')
            console.log(allcomppeolist.data)
        }
    })
}

//主体+成员下拉选中的数据
const selectedPath = reactive({
    data:[]
})
//联动数据，过滤数据，只能选一个一级多个二级
const handleChange = (val)=>{
    console.log(val)
    //只能选一个主体
    if(val && val.length > 0){
        // 获取所有一级节点值（父节点ID）
        const parentIds = val.map(item => item[0])
        // 去重获取所有唯一的父节点
        const uniqueParentIds = [...new Set(parentIds)]
        
        // 如果存在多个父节点，只保留最后一个选中的父节点及其子节点
        if(uniqueParentIds.length > 1){
            const lastParentId = uniqueParentIds[uniqueParentIds.length - 1]
            // 筛选出最后一个父节点的所有相关节点
            const newVal = val.filter(item => item[0] === lastParentId)
            // 延迟更新确保界面正确响应
            setTimeout(()=>{
                selectedPath.data = newVal
                console.log(selectedPath.data)
            }, 0)
        }
    }
    
}

//获取当前时间年月日时分秒
const getNowDate = ()=>{
    var date = new Date();
    var sign2 = ":";
    var year = date.getFullYear() // 年
    var month = date.getMonth() + 1; // 月
    var day = date.getDate(); // 日
    var hour = date.getHours(); // 时
    var minutes = date.getMinutes(); // 分
    var seconds = date.getSeconds() //秒
    var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
    var week = weekArr[date.getDay()];
    // 给一位数的数据前面加 "0"
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    console.log(year + "-" + month + "-" + day + " " + hour + sign2 + minutes )
    //返回格式2022-11-25 10:25:39
    
    return year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
}

</script>
<style scoped>
  /* .t_content_view{
    padding: 20px;
    color: #333333;
  } */
  
  .t_speak_box{
    width: 460px;
    border: 1px solid #4F46E5;
    border-radius: 5px;
  }
  :deep(.t_speak_input .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    background-color: #F1F3F9;
    resize: none;
  }
  :deep(.t_speak_box .el-input__wrapper){
    background-color: #F1F3F9;
    box-shadow:0 0 0 0px ;
    height: 38px;
  }
  .t_emoji_img{
    width: 20px;
    margin-left: 20px;
    margin-top: 5px;
    cursor: pointer;
  }
  .t_web_title{
    color: #333333;
    font-size: 15px;
    margin-bottom: 5px;
  }
  :deep(.t_up_img_box .el-upload-list){
    display: flex;
    flex-wrap: wrap;
  }
  :deep( .t_up_img_box .el-upload-list__item){
    /* width: 94px; */
    margin-right: 10px;
  }
  :deep( .t_up_img_box .el-upload-list--picture .el-upload-list__item-status-label){
    z-index: 1;
  }
  :deep( .t_up_img_box .el-upload-list--picture .el-upload-list__item .el-icon--close){
    top: 0;
    z-index: 2;
  }
  :deep( .t_up_img_box .el-upload-list__item .el-icon--close){
    right: 0;
  }

  :deep( .t_up_video_box .el-upload-list__item){
    width: 200px;
    margin-right: 10px;
  }
  .t_line{
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  :deep(.t_choosetime .el-input__wrapper){
    background-color: #F1F3F9;
    box-shadow:0 0 0 0px 
  }
  .t_js_box{
    font-size: 13px;
    color: #777777;
    margin-top: 20px;
  }
  .t_js_box span{
    color: #4F46E5;
    cursor: pointer;
  }
  .t_sxbox{
    background-color: #F1F3F9;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    
  }
  .t_sxtitle{
    font-size: 15px;
    width: 460px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .t_choosedtag{
    margin-right:10px;
    margin-bottom:20px;
    
  }
  .t_tagchoose_box{
    margin-bottom:30px
  }
  .t_all_tag{
    margin-top: 10px;
    margin-right: 10px;
  }
  /* .t_cz_box{
    display: flex;
    justify-content:space-around
  } */
  .t_sxtips{
    background-color: #F1F3F9;
    border: 1px solid #4F46E5;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

</style>
